<link rel="stylesheet" href="/assets/css/app/contatos-1.css">
<header class="main-header" data-astro-cid-qgrrgaau>
  <div class="flex items-center justify-between h-full ps-24 pe-8" data-astro-cid-qgrrgaau>
    <div class="header__actions flex items-center gap-4">
      <div class="filtros-wrapper" *ngIf="showSearchLista" style="display: none;">
        <input type="text" class="flex-1 border-none" placeholder="(Digite o nome da lista)">
        <button
          class="bg-brand-gray-200 w-10 aspect-square flex items-center justify-center rounded hover:bg-brand-primary hover:text-white transition-all duration-200 group">
          <span
            class="material-symbols-outlined text-brand-primary group-hover:text-white transition-all duration-200">filter_list</span>
        </button>
        <button
          class="bg-brand-gray-200 w-10 aspect-square flex items-center justify-center rounded hover:bg-brand-primary hover:text-white transition-all duration-200 group">
          <span
            class="material-symbols-outlined text-brand-primary group-hover:text-white transition-all duration-200">search</span>
        </button>
      </div>
    </div>
    <div class="header__actions flex items-center gap-4">
      <div class="filtros-wrapper" *ngIf="showSearchContatos" style="display: none;">
        <input type="text" class="flex-1 border-none" placeholder="(Digite o nome do contato)">
        <button
          class="bg-brand-gray-200 w-10 aspect-square flex items-center justify-center rounded hover:bg-brand-primary hover:text-white transition-all duration-200 group">
          <span
            class="material-symbols-outlined text-brand-primary group-hover:text-white transition-all duration-200">filter_list</span>
        </button>
        <button
          class="bg-brand-gray-200 w-10 aspect-square flex items-center justify-center rounded hover:bg-brand-primary hover:text-white transition-all duration-200 group">
          <span
            class="material-symbols-outlined text-brand-primary group-hover:text-white transition-all duration-200">search</span>
        </button>
      </div>
    </div>

    <div class="user-info-wrapper flex  h-full items-center ml-auto" data-astro-cid-qgrrgaau>
      <div class="text-sm text-right hidden lg:flex flex-col" data-astro-cid-qgrrgaau>
        <p data-astro-cid-qgrrgaau>Seu saldo</p>
        <p class="font-bold text-brand-primary" data-astro-cid-qgrrgaau>{{saldo.quantidade | formatarNumeroBR}}</p>        
      </div>
      <span class="h-10 w-px bg-brand-gray-400 mx-8 opacity-20 hidden lg:block" data-astro-cid-qgrrgaau></span>
      <div class="items-center relative hidden lg:flex" data-astro-cid-qgrrgaau>
        <button class="notificacoes-trigger text-brand-primary btn-notificacoes" data-astro-cid-qgrrgaau (click)="toggleNotificacoes()">
          <span class="material-symbols-outlined filled" data-astro-cid-qgrrgaau>
            notifications
          </span>
          <span class="dot" *ngIf="temNotificacoes" data-astro-cid-qgrrgaau></span>
        </button>

        <div class="notificacoes-lista" [class.hidden]="!isNotificacoesVisible" [@fadeInOut] data-astro-cid-qgrrgaau>
          <div *ngFor="let notificacao of notificacoes" class="notificacao-item" data-astro-cid-qgrrgaau>
            <div class="notificacao-content">
              <div class="notificacao-texto">
                <p data-astro-cid-qgrrgaau>{{notificacao.mensagem}}</p>
                <small data-astro-cid-qgrrgaau>{{notificacao.data | date:'dd/MM/yyyy'}}</small>
              </div>
              <button class="btn-marcar-lida" (click)="marcarComoLida(notificacao); $event.stopPropagation()"
                title="Remover notificação">
                <span class="material-symbols-outlined">
                  delete
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <span class=" h-10 w-px bg-brand-gray-400 mx-8 opacity-20 hidden lg:block" data-astro-cid-qgrrgaau></span>
      <div class="user-menu-trigger flex items-center gap-4" data-astro-cid-qgrrgaau>
        <div data-astro-cid-qgrrgaau (click)="toggleUserMenu()" style="cursor: pointer;">
          <img src="assets/img/avatar.png" alt="" class="avatar" data-astro-cid-qgrrgaau>
        </div>
        <div class="text-brand-primary" data-astro-cid-qgrrgaau (click)="toggleUserMenu()" style="cursor: pointer;">
          <p data-astro-cid-qgrrgaau>{{getNomeUsuario()}}</p>
        </div>
        <button class="flex text-brand-primary" data-astro-cid-qgrrgaau (click)="toggleUserMenu()">
          <span class="material-symbols-outlined" data-astro-cid-qgrrgaau>
            keyboard_arrow_down
          </span>
        </button>

        <div class="user-menu-lista" [class.hidden]="!isUserMenuVisible" [@fadeInOut] data-astro-cid-qgrrgaau>
          <div class="user-menu-item" data-astro-cid-qgrrgaau (click)="navegarParaMeusDados()">
            <span class="material-symbols-outlined">
              badge
            </span>
            <p>Meus dados</p>
          </div>
          <div class="user-menu-item" (click)="navegarParaUsuarios()" data-astro-cid-qgrrgaau *appTemPermissao="EnumPermissao.CriarNovosUsuarios">
            <span class="material-symbols-outlined">
              group
            </span>
            <p>Usuários</p>
          </div>
          <div class="user-menu-item" data-astro-cid-qgrrgaau (click)="navegarParaRelatorios($event)" *appTemPermissao="EnumPermissao.VisualizarRelatorios">
            <span class="material-symbols-outlined">
              bar_chart
            </span>
            <p>Relatórios</p>
          </div>
          <div class="user-menu-item" data-astro-cid-qgrrgaau (click)="navegarParaRecargas($event)" *appTemPermissao="EnumPermissao.FazerRecarga">
            <span class="material-symbols-outlined">
              youtube_searched_for
            </span>
            <p>Recargas</p>
          </div>
          <div class="user-menu-item" (click)="logout()" data-astro-cid-qgrrgaau>
            <span class="material-symbols-outlined">
              logout
            </span>
            <p>Sair</p>
          </div>
          <div class="user-menu-ip" data-astro-cid-qgrrgaau>
            <p class="user-menu-ip-label">Meu IP:</p>
            <p class="user-menu-ip-value">{{userIp}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
<aside class="main-nav" data-astro-cid-krcbuwbt>
  <div class="main-nav__header" data-astro-cid-krcbuwbt>
    <a routerLink="/area-logada/home" class="main-nav__logo-link" data-astro-cid-krcbuwbt>
      <img src="assets/img/logo-nova-vida.png" alt="Nova Vida TI - Atalho" class="main-nav__logo"
        data-astro-cid-krcbuwbt>
      <img src="assets/img/logo-nova-vida-mini.png" alt="Nova Vida TI - Atalho"
        class="main-nav__logo main-nav__logo--mobile" data-astro-cid-krcbuwbt>
    </a>
    
    <!-- Botão toggle -->
    <button class="btn-toggle-menu" type="button" data-astro-cid-krcbuwbt (click)="toggleMenu()">
      <span class="material-symbols-outlined" *ngIf="!menuExpanded">
        menu
      </span>
      <span class="material-symbols-outlined" *ngIf="menuExpanded">
        menu_open
      </span>
    </button>
  </div>
  <nav class="nav" data-astro-cid-krcbuwbt>
    <ul class="menu p-0" data-astro-cid-krcbuwbt>
      <li class="menu-item" data-astro-cid-krcbuwbt>
        <a routerLink="/area-logada/home" class="no-underline" data-astro-cid-krcbuwbt>
          <span class="icone material-symbols-outlined" data-astro-cid-krcbuwbt>manage_search</span>
          <span class="texto" data-astro-cid-krcbuwbt>Início</span>
        </a>
      </li>
      <li class="menu-item" data-astro-cid-krcbuwbt *appTemPermissao="EnumPermissao.FazerSegmentacao">
        <a href="#" (click)="navegarParaSegmentacao($event)" class="no-underline" data-astro-cid-krcbuwbt>
          <span class="icone material-symbols-outlined filled" data-astro-cid-krcbuwbt>ads_click</span>
          <span class="texto" data-astro-cid-krcbuwbt>Segmentação</span>
        </a>
      </li>
      <li class="menu-item" data-astro-cid-krcbuwbt>
        <a routerLink="/area-logada/listas" class="no-underline" data-astro-cid-krcbuwbt>
          <span class="icone material-symbols-outlined filled" data-astro-cid-krcbuwbt>contact_page</span>
          <span class="texto" data-astro-cid-krcbuwbt>Listas salvas</span>
        </a>
      </li>      
    </ul>
  </nav>
</aside>
<main class="main-content">  
  <toast-container></toast-container>
  <router-outlet></router-outlet>  
</main>